import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavExclamationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6156_151)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.8389 1.68066C13.187 0.902338 14.8482 0.902342 16.1963 1.68066L23.6133 5.96289C24.9612 6.74126 25.792 8.1798 25.792 9.73633V18.2998C25.792 19.8564 24.9613 21.2949 23.6133 22.0732L16.1963 26.3555C14.8482 27.1337 13.1869 27.1338 11.8389 26.3555L4.42285 22.0732C3.07475 21.2949 2.24414 19.8565 2.24414 18.2998V9.73633C2.24414 8.17968 3.07476 6.74122 4.42285 5.96289L11.8389 1.68066Z",
				fill: "#E2EDFF",
				stroke: "#354C8F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6095 7.90154L13.0198 14.8774C13.0421 15.2562 13.2026 15.6136 13.4709 15.8819C13.7735 16.1844 14.2639 16.1844 14.5665 15.8819C14.8348 15.6136 14.9953 15.2562 15.0176 14.8774L15.4279 7.90154C15.451 7.50977 15.2644 7.13517 14.9379 6.91748C14.3813 6.5464 13.6561 6.5464 13.0995 6.91748C12.773 7.13517 12.5864 7.50977 12.6095 7.90154Z",
				fill: "#354C8F"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 14.0187,
				cy: 20.2863,
				r: 1.44643,
				fill: "#354C8F"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6156_151",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 28,
			fill: "white",
			transform: "translate(1)"
		})
	}) })]
});
export default SvgNavExclamationIcon;
